import {useState} from "react";
import Icon from "../components/Icon";
import Eyebrow from "../components/Eyebrow";
import TechStack from "../components/TechStack";

export default function Home() {
    const [copied, setCopied] = useState(false);
    const email = "iolivera14@outlook.com";

    const handleCopy = () => {
        navigator.clipboard?.writeText(email);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <section className="hero">
            <div className="hero-grid">
                <div className="hero-left">
                    <Eyebrow>DEVELOPER</Eyebrow>
                    <h1 className="hero-name">Iván Olivera</h1>
                    <p className="hero-lead">
                        Hi <span className="wave">👋🏻</span>, I'm an enthusiastic Developer from <span className="hl">Montevideo, Uruguay</span>.
                        I build
                        visually appealing, user-friendly products end&#8209;to&#8209;end.
                    </p>

                    <div className="hero-actions">
                        <a className="btn-primary" href="/cv-iolivera.pdf" target="_blank" rel="noreferrer">
                            Download CV <Icon name="download" style={{width: 16, height: 16}}/>
                        </a>
                        <div className="social-row">
                            <a
                                href="https://www.linkedin.com/in/iolivera1/"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-btn"
                                aria-label="LinkedIn"
                            >
                                <Icon name="linkedin" style={{width: 20, height: 20}}/>
                            </a>
                            <a
                                href="https://github.com/Iolivera1"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-btn"
                                aria-label="GitHub"
                            >
                                <Icon name="github" style={{width: 20, height: 20}}/>
                            </a>
                            <button className="icon-btn email-btn" onClick={handleCopy} title="Copy email">
                                <Icon
                                    name={copied ? "check" : "copy"}
                                    style={{
                                        width: 17,
                                        height: 17,
                                        color: copied ? "var(--accent)" : "currentColor",
                                    }}
                                />
                                <span className="email-text">{copied ? "Copied!" : email}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="hero-right">
                    <div className="portrait-scene">
                        <div className="portrait">
                            <div
                                className="portrait-img"
                                style={{
                                    backgroundImage: "url(/images/profile2-web.webp)",
                                    backgroundPosition: "50% 16%",
                                }}
                            />
                            <div className="portrait-glow"/>
                        </div>
                        <span className="float-badge fb-1">
              <img src="/tech-stack/react-native.svg" alt="React Native"/>
            </span>
                        <span className="float-badge fb-2">
              <img src="/tech-stack/typescript.svg" alt="TypeScript"/>
            </span>
                        <span className="float-badge fb-3">
              <img src="/tech-stack/expo-icon.svg" alt="Expo"/>
            </span>
                    </div>
                </div>
            </div>

            <TechStack/>
        </section>
    );
}
